import React from "react";
import { MDBCol, MDBIcon } from "mdbreact";
import "./Team.css";

const TeamMember = (props) => {
  const { social } = props;
  return (
    <MDBCol lg="3" md="6" className="mb-lg-0 mb-5">
      <img
        tag="img"
        src={props.photo}
        className="rounded-circle z-depth-1 img-fluid md-avatar size-4"
        alt="Sample avatar"
      />
      <h5 className="font-weight-bold grey-text mt-4 mb-3">{props.name}</h5>
      <p className="text-uppercase blue-text">{props.position}</p>
      <p className="grey-text">{props.description}</p>
      { social !== undefined ? 
      <ul className="list-unstyled mb-0">
        {social.map((prop, key) => {
          return (
            <a key={prop.title + key} href={prop.link} className="p-2 fa-lg">
              <MDBIcon fab icon={prop.title} className="blue-text" />
            </a>
          );
        })}
      </ul> : null }
    </MDBCol>
  );
};

export default TeamMember;



// WEBPACK FOOTER //
// ./src/components/TeamMember/TeamMember.jsx